import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { consentChoice, setConsent } from './analytics';
import { GA_MEASUREMENT_ID } from './config';
import { useI18n } from './i18n';

// Asks once whether Google Analytics may set cookies. Declining keeps the site
// working the same; only Google Analytics stays off.
function CookieBanner() {
  const { t, tr } = useI18n();
  const [choice, setChoice] = useState(consentChoice);
  const showing = Boolean(GA_MEASUREMENT_ID && !choice);
  // Room at the bottom of the page, so the banner never covers links like Log in.
  useEffect(() => {
    document.body.classList.toggle('has-cookie-banner', showing);
    return () => document.body.classList.remove('has-cookie-banner');
  }, [showing]);
  if (!showing) return null;

  function choose(value) {
    setConsent(value);
    setChoice(value);
  }

  return (
    <div className="cookie-banner" role="region" aria-label={t('Cookies')}>
      <p>
        {tr('We use Google Analytics cookies to understand how people find and use Market Matrix. They are only set if you accept. <0>Privacy Policy</0>',
          [(x) => <Link to="/privacy">{x}</Link>])}
      </p>
      <div className="cookie-banner-actions">
        <button type="button" className="small" onClick={() => choose('accepted')}>{t('Accept')}</button>
        <button type="button" className="secondary small" onClick={() => choose('declined')}>{t('Decline')}</button>
      </div>
    </div>
  );
}

export default CookieBanner;
